import ApiGetOptions from '@/datatypes/api-get-options';
import ApiService from '@/services/api/ApiService';
import decamelizeKeysDeep from 'decamelize-keys-deep';

export default class TaxRateService extends ApiService {
  public list(params) {
    return this.call(new ApiGetOptions(
      {
        url: '/billing_tax_rates',
        params: decamelizeKeysDeep(params),
      },
    ));
  }
}
